<template>
  <div>
    <div class="question-container">
      <div class="title">
        服务问题概览
      </div>
      <div class="time-tabs">
        <div class="time-block">
          <div
            class="time-text"
            @click="switchTimeType('day')"
          >
            昨日
          </div>
          <div
            class="active-line"
            :style="{ visibility: timeType === 'day' ? 'visible' : 'hidden'}"
          ></div>
        </div>
        <div class="time-block">
          <div
            class="time-text"
            @click="switchTimeType('month')"
          >
            本月
          </div>
          <div
            class="active-line"
            :style="{ visibility: timeType === 'month' ? 'visible' : 'hidden' }"
          ></div>
        </div>
      </div>
      <div class="question-tabs">
        <div
          v-for="item in poiQuestionGroups"
          :key="item.indicatorCode"
          class="question-block"
          :class="{ 'question-block-active': activeQuestion.indicatorCode === item.indicatorCode }"
          @click="switchQuestion(item)"
        >
          <div class="title">
            {{ INDICATOR_CODES_MAP[item.indicatorCode] }}
            <van-icon
              name="question-o"
              color="#999"
              style="margin-left: 0.068rem;"
              @click.stop="showExplain = true"
            />
          </div>
          <div class="value">
            <span class="count">{{ item.count }}</span><span>{{ item.indicatorCode===3?'条':'台' }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="detailLoading"
        class="detail-loading-card"
      >
        <img src="@/assets/img/icon_rotation_animation@3x.png" />
      </div>
      <div v-else>
        <div
          v-if="activeQuestion.count>0"
          class="question-text"
        >
          {{ activeQuestion.questionText }}
        </div>
        <div
          v-if="activeQuestion.indicatorCode === 1 || activeQuestion.indicatorCode === 2"
          class="question-detail"
        >
          <div class="question-detail-title">
            <div class="question-detail-title-col1">
              机柜SN
            </div>
            <div class="question-detail-title-col2">
              {{ INDICATOR_CODES_MAP[activeQuestion.indicatorCode] }}
            </div>
          </div>
          <div
            v-if="activeQuestion.count===0"
            class="no-question-text"
          >
            {{ timeType==="day"?"昨日":"本月" }}门店服务表现很好，无{{ INDICATOR_CODES_MAP[activeQuestion.indicatorCode] }}，再接再厉呀！
          </div>
          <div class="question-detail-content">
            <div
              v-for="(item, index) in snQuestionDetail"
              :key="item.cabinetSn"
              class="question-detail-item"
            >
              <div class="question-detail-item-main">
                <div class="question-detail-col1">
                  {{ item.cabinetSn }}
                </div>
                <div class="question-detail-col2">
                  {{ activeQuestion.questionDetailText }}
                </div>
              </div>
              <div
                v-if="timeType==='month'"
                class="question-detail-item-others"
              >
                <div style="margin-bottom:0.06rem;display:flex;align-items:center;">
                  <span
                    v-if="activeQuestion.indicatorCode === 1"
                    style="font-weight: 600;color: #222;"
                  >共断电{{ item.cnt }}天</span>
                  <span
                    v-if="activeQuestion.indicatorCode === 2"
                    style="font-weight: 600;color: #222;"
                  >共偏移{{ item.cnt }}天</span>
                  <van-icon
                    v-if="item.cnt>0&&!item.showDayList"
                    name="arrow-down"
                    color="#999"
                    style="margin:0 0 0.015rem 0.1rem;"
                    @click="showDayList(item.cabinetSn, index)"
                  />
                  <van-icon
                    v-if="item.cnt>0&&item.showDayList"
                    name="arrow-up"
                    color="#999"
                    style="margin:0 0 0.015rem 0.1rem;"
                    @click="collapseDayList(index)"
                  />
                </div>
                <div
                  v-if="item.cnt>0&&item.showDayList"
                  style="line-height:0.36rem;"
                >
                  {{ item.dayList }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="activeQuestion.indicatorCode === 3"
          class="question-detail"
        >
          <div class="question-detail-title">
            <div class="question-detail-title-col1">
              客诉类型
            </div>
            <div class="question-detail-title-col2">
              数量
            </div>
          </div>
          <div
            v-if="activeQuestion.count===0"
            class="no-question-text"
          >
            {{ timeType==="day"?"昨日":"本月" }}门店服务表现很好，无{{ INDICATOR_CODES_MAP[activeQuestion.indicatorCode] }}，再接再厉呀！
          </div>
          <div class="question-detail-content">
            <div
              v-for="(item, index) in snQuestionDetail"
              :key="item.custComplaintType"
              class="question-detail-item"
            >
              <div class="question-detail-item-main">
                <div class="question-detail-col1">
                  {{ item.custComplaintTypeDesc }}
                  <van-icon
                    v-if="item.hasSubComplaint && !item.showSubComplaint"
                    name="arrow-down"
                    color="#999"
                    style="margin:0 0 0.2vw 1.5vw;"
                    @click="showSubComplaintFunc(index)"
                  />
                  <van-icon
                    v-if="item.hasSubComplaint && item.showSubComplaint"
                    name="arrow-up"
                    color="#999"
                    style="margin:0 0 0.2vw 1.5vw;"
                    @click="showSubComplaintFunc(index)"
                  />
                </div>
                <div
                  v-if="!item.showSubComplaint"
                  class="question-detail-col2"
                  :style="{ color: item.cnt > 0 ? '#FF2727' : '#222' }"
                >
                  {{ item.cnt }}条
                </div>
              </div>
              <div
                v-if="timeType==='month' && !item.showSubComplaint"
                class="question-detail-item-others"
              >
                <div style="margin-bottom:0.06rem;display:flex;align-items:center;">
                  <span style="font-weight: 600;color: #222;">客诉发生{{ item.userComplaintDayCnt }}天</span>
                  <van-icon
                    v-if="item.cnt>0&&!item.dayList"
                    name="arrow-down"
                    color="#999"
                    style="margin:0 0 0.015rem 0.1rem;"
                    @click="showDayList(item.custComplaintType, index)"
                  />
                  <van-icon
                    v-if="item.cnt>0&&item.dayList"
                    name="arrow-up"
                    color="#999"
                    style="margin:0 0 0.015rem 0.1rem;"
                    @click="collapseDayList(index)"
                  />
                </div>
                <div
                  v-if="item.cnt>0&&item.dayList"
                  style="line-height:0.36rem;"
                >
                  {{ item.dayList }}
                </div>
              </div>
              <div v-if="item.hasSubComplaint && item.showSubComplaint">
                <div
                  v-for="(subItem, subIndex) in item.subComplaintList"
                  :key="subIndex"
                  class="question-detail-item"
                >
                  <div class="question-detail-item-main">
                    <div
                      class="question-detail-col1"
                      style="font-weight:normal;"
                    >
                      {{ subItem.custComplaintTypeDesc }}
                    </div>
                    <div
                      class="question-detail-col2"
                      :style="{ color: subItem.cnt > 0 ? '#FF2727' : '#222' }"
                    >
                      {{ subItem.cnt }}条
                    </div>
                  </div>
                  <div
                    v-if="timeType==='month'"
                    class="question-detail-item-others"
                  >
                    <div style="margin-bottom:0.8vw">
                      <span style="font-weight: 500;color: #222;">客诉发生{{ subItem.userComplaintDayCnt }}天</span>
                      <van-icon
                        v-if="subItem.cnt>0&&!subItem.showDayList"
                        name="arrow-down"
                        color="#999"
                        style="margin:0 0 0.2vw 1.5vw;"
                        @click="showSubCustComplaintDayList(subItem.custComplaintType, index, subIndex)"
                      />
                      <van-icon
                        v-if="subItem.cnt>0&&subItem.showDayList"
                        name="arrow-up"
                        color="#999"
                        style="margin:0 0 0.2vw 1.5vw;"
                        @click="collapseSubDayList(index, subIndex)"
                      />
                    </div>
                    <div
                      v-if="subItem.cnt>0&&subItem.showDayList"
                      style="line-height:4.8vw;"
                    >
                      {{ subItem.dayList }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      v-if="showScrollTopBtn"
      src="@/assets/img/scroll-top@3x.png"
      class="scrollTopBtn"
      @click="handleScrollTop"
    />
    <div
      v-if="!detailLoading"
      class="footer"
    >
      没有更多了～
    </div>
    <van-popup
      v-model="showExplain"
      position="bottom"
      round
    >
      <div class="popup-title">
        数据说明
      </div>
      <img
        src="@/assets/img/close-gray@3x.png"
        @click="showExplain = false"
      />
      <div class="popup-content">
        <div
          v-for="(item,index) in INDICATOR_EXPLAIN_LIST"
          :key="index"
        >
          <div style="font-weight:600;">
            {{ item.title }}
          </div>
          <div
            style="color:#666;"
            v-html="item.value.replace(/\n/g, '<br>')"
          >
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <div
          class="footer-btn"
          @click="showExplain = false"
        >
          知道了
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import ServiceLevelApi from '@/api/serviceLevel';
import { INDICATOR_CODES_MAP, INDICATOR_EXPLAIN_LIST } from '@/constants/serviceLevel';
import Store from '@/store/index';
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';

export default {
  name: 'PoiDetailQuestion',
  data() {
    return {
      timeType: 'day',
      detailLoading: false,
      poiId: '',
      showScrollTopBtn: false,
      poiQuestionGroups: [
        {
          indicatorCode: 1,
          count: 0,
          questionText: '断电将导致机柜无法借还，影响流水收益，建议重新通电并保持持续通电状态！',
          questionDetailText: '24小时断电',
        },
        {
          indicatorCode: 2,
          count: 0,
          questionText: '偏移影响门店充电宝借还服务，建议尽快联系您的业务经理进行处理！',
          questionDetailText: '超过100m偏移',
        },
        {
          indicatorCode: 3,
          count: 0,
          questionText: '关注用户体验有助门店经营，建议尽快联系您的业务经理进行处理！',
        },
      ],
      activeQuestion: {
        indicatorCode: 1,
        count: 0,
        questionText: '',
      },
      snQuestionDetail: [],
      INDICATOR_CODES_MAP,
      showExplain: false,
      INDICATOR_EXPLAIN_LIST,
      partnerId: Store.getters['partnerModule/id'],
      cid: this.$CID.ServiceLevelPoiDetail,
    };
  },
  async mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.$store.commit('setLoading', true);
    await this.poiQuestionCnt();
    await this.initQuestion();
    this.$store.commit('setLoading', false);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    async switchTimeType(type) {
      this.timeType = type;
      await this.poiQuestionCnt();
      await this.initQuestion();
      if (type === 'month') {
        tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_DETAIL_MONTH, null, { cid: this.cid });
      } else {
        tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_DETAIL_DAY, null, { cid: this.cid });
      }
    },
    getYesterdayMonthDate() {
      const today = new Date();
      today.setDate(today.getDate() - 1); // 将日期减去1天
      // 昨天的日期
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
      const day = String(today.getDate()).padStart(2, '0');
      const yesterday = `${year}-${month}-${day}`; // 格式化为 YYYYMMDD
      // 昨天所在月份的第一天
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const firstDay = `${firstDayOfMonth.getFullYear()}${String(firstDayOfMonth.getMonth() + 1).padStart(2, '0')}${String(firstDayOfMonth.getDate()).padStart(2, '0')}`;
      return {
        yesterday,
        firstDay,
      };
    },
    async poiQuestionCnt() {
      // 请求获得的数量
      this.poiId = this.$route.query.poiId;
      const { yesterday, firstDay } = this.getYesterdayMonthDate();
      const queryBeginDT = this.timeType === 'month' ? firstDay : yesterday;
      const queryEndDT = yesterday;
      const params = {
        queryBeginDT,
        queryEndDT,
        poiId: this.poiId,
        partnerId: this.partnerId,
      };
      const { data, error } = await ServiceLevelApi.getPoiOptimizeCnt(params);
      if (!error && data) {
        this.poiQuestionGroups.forEach((item) => {
          switch (item.indicatorCode) {
          case 1:
            item.count = data.powerOffCnt;
            break;
          case 2:
            item.count = data.pointOffCnt;
            break;
          case 3:
            item.count = data.custComplaintCnt;
            break;
          default:
            break;
          }
        });
      }
    },
    async initQuestion() {
      const foundQuestion = this.poiQuestionGroups.find((item) => item.count > 0);
      this.activeQuestion = foundQuestion || this.poiQuestionGroups[0];
      await this.poiQuestionDetail();
    },
    async switchQuestion(question) {
      this.activeQuestion = question;
      await this.poiQuestionDetail();
      const indicatorCode = question.indicatorCode;
      switch (indicatorCode) {
      case 1:
        tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_DETAIL_POWER_OFF, { time: this.timeType }, { cid: this.cid });
        break;
      case 2:
        tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_DETAIL_POINT_OFF, { time: this.timeType }, { cid: this.cid });
        break;
      case 3:
        tracker.sendModuleClick(BID.SERVICE_LEVEL_POI_DETAIL_COMPLAINT, { time: this.timeType }, { cid: this.cid });
        break;
      default:
        break;
      }
    },
    async poiQuestionDetail() {
      // 请求问题详情
      this.detailLoading = true;
      this.snQuestionDetail = [];
      this.snQuestionDetail = await this.handlePoiQuestionDetail();
      this.detailLoading = false;
    },
    async showSubComplaintFunc(index) {
      if (this.snQuestionDetail[index].showSubComplaint) {
        this.snQuestionDetail[index].showSubComplaint = false;
      } else {
        this.snQuestionDetail[index].showSubComplaint = true;
        const custComplaintType = this.snQuestionDetail[index].custComplaintType;
        // 减少请求次数
        if (!this.snQuestionDetail[index].subComplaintList || this.snQuestionDetail[index].subComplaintList.length === 0) {
          const result = await this.handlePoiQuestionDetail(custComplaintType);
          this.snQuestionDetail[index].subComplaintList = result;
        }
      }
      this.$forceUpdate();
    },
    async handlePoiQuestionDetail(custComplaintType = 0) {
      // 请求问题详情
      const { yesterday, firstDay } = this.getYesterdayMonthDate();
      const queryBeginDT = this.timeType === 'month' ? firstDay : yesterday;
      const queryEndDT = yesterday;
      const params = {
        queryBeginDT,
        queryEndDT,
        poiId: this.poiId,
        indicatorCode: this.activeQuestion.indicatorCode,
        partnerId: this.partnerId,
        ...(custComplaintType ? { custComplaintType } : {}),
      };
      const { data, error } = await ServiceLevelApi.getPoiOptimizeDetail(params);
      if (!error && data) {
        return data || [];
      }
      return [];
    },
    async showDayList(item, index) {
      if (!this.snQuestionDetail[index].dayList || this.snQuestionDetail[index].dayList.length === 0) {
        const { yesterday, firstDay } = this.getYesterdayMonthDate();
        const queryBeginDT = this.timeType === 'month' ? firstDay : yesterday;
        const queryEndDT = yesterday;
        const indicatorCode = this.activeQuestion.indicatorCode;
        let params = {};
        if (indicatorCode === 3) {
          params = {
            queryBeginDT,
            queryEndDT,
            poiId: this.poiId,
            indicatorCode,
            custComplaintType: item,
            partnerId: this.partnerId,
          };
        } else {
          params = {
            queryBeginDT,
            queryEndDT,
            poiId: this.poiId,
            indicatorCode,
            cabinetSn: item,
            partnerId: this.partnerId,
          };
        }
        const { data, error } = await ServiceLevelApi.getPoiOptimizeDt(params);
        if (!error && data) {
          this.snQuestionDetail[index].dayList = data.join('、');
          this.snQuestionDetail[index].showDayList = true;
        }
      } else {
        this.snQuestionDetail[index].showDayList = true;
      }
      this.$forceUpdate();
    },
    async showSubCustComplaintDayList(item, index, subIndex) {
      if (!this.snQuestionDetail[index].subComplaintList[subIndex].dayList || this.snQuestionDetail[index].subComplaintList[subIndex].dayList.length === 0) {
        const { yesterday, firstDay } = this.getYesterdayMonthDate();
        const queryBeginDT = this.timeType === 'month' ? firstDay : yesterday;
        const queryEndDT = yesterday;
        const params = {
          queryBeginDT,
          queryEndDT,
          poiId: this.poiId,
          indicatorCode: this.activeQuestion.indicatorCode,
          custComplaintType: item,
          partnerId: this.partnerId,
        };
        const { data, error } = await ServiceLevelApi.getPoiOptimizeDt(params);
        if (!error && data) {
          this.snQuestionDetail[index].subComplaintList[subIndex].dayList = data.join('、');
          this.snQuestionDetail[index].subComplaintList[subIndex].showDayList = true;
        }
      } else {
        this.snQuestionDetail[index].subComplaintList[subIndex].showDayList = true;
      }
      this.$forceUpdate();
    },

    collapseDayList(index) {
      this.snQuestionDetail[index].showDayList = false;
      this.$forceUpdate();
    },

    collapseSubDayList(index, subIndex) {
      this.snQuestionDetail[index].subComplaintList[subIndex].showDayList = false;
      this.$forceUpdate();
    },

    handleScrollTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.showScrollTopBtn = false;
    },
    handleScroll() {
      this.showScrollTopBtn = window.scrollY > window.innerHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
.question-container {
  padding: 0.3rem 0.24rem 0 0.24rem;
  background-color: #fff;
  width: 100%;
  margin-top: 0.24rem;
  border-radius: 0.24rem;
  .title {
    font-size: 0.32rem;
    font-weight: 600;
    line-height: 0.32rem;
  }
  .time-tabs {
    display: flex;
    margin-top: 0.1rem;
    padding: 0.2rem 0 0 0.03rem;
    .time-block {
      font-size: 0.3rem;
      margin-right: 0.6rem;
      .time-text {
        line-height: 0.3rem;
        font-weight: 600;
        font-size: 0.28rem;
      }
      .active-line {
        height: 0.08rem;
        width: 0.3rem;
        background-color: #FFCC33;
        border-radius: 0.06rem;
        margin: 0.12rem auto 0 auto;
      }
    }
  }
  .question-tabs{
    display: flex;
    justify-content: space-between;
    margin-top: 0.24rem;
    .question-block {
      border-radius: 0.18rem;
      padding: 0.24rem 0 0.24rem 0.24rem;
      width: 2.1rem;
      border: 2px solid #E5E5E5;
      .title {
        display: flex;
        align-items: center;
        font-size: 0.24rem;
        line-height: 0.24rem;
        height: 0.24rem;
      }
      .value {
        font-size: 0.28rem;
        height: 0.52rem;
        margin-bottom: 0.06rem;
        .count {
          font-size: 0.52rem;
          margin-right: 0.06rem;
          font-family: MTfin2.0;
          font-variation-settings: "opsz" auto;
          font-feature-settings: "kern" on;
        }
      }
    }
    .question-block-active {
      background-color: #FFFAE6;
      border: 2px solid #FFD100;
    }
  }
  .detail-loading-card {
    width: 100%;
    height: 10vh;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 4.267vw;
    }
  }
  .question-text {
    border-radius: 0.12rem;
    background: #FAFAFA;
    font-size: 0.24rem;
    line-height: 0.34rem;
    color: #666666;
    padding: 0.18rem;
    margin-top: 0.24rem;
  }
  .question-detail {
    padding: 0.1rem 0.06rem 0.2rem 0.06rem;
    .question-detail-title {
      padding: 0.2rem 0;
      font-size: 0.24rem;
      font-weight: 600;
      line-height: 0.24rem;
      color: #999;
      display: flex;
      position: sticky;
      top: 0px;
      background-color: #fff;
      z-index: 10;
      .question-detail-title-col1 {
        width: 3.91rem;
        float: left;
      }
      .question-detail-title-col2 {
        overflow: hidden;
      }
    }
    .no-question-text {
      border-radius: 1.6vw;
      background: #fff;
      font-size: 3.2vw;
      line-height: 3.2vw;
      padding: 4vw 0 2.667vw 0;
    }
    .question-detail-content {
      .question-detail-item {
        padding: 0.2rem 0;
        .question-detail-item-main {
          display: flex;
          font-size: 0.28rem;
          line-height: 0.28rem;
          .question-detail-col1 {
            width: 3.91rem;
            float: left;
            font-weight: 600;
          }
          .question-detail-col2 {
            overflow: hidden;
            color: #FF2727;
          }
        }
        .question-detail-item-others {
          border-radius: 0.12rem;
          background: #FAFAFA;
          font-size: 0.24rem;
          line-height: 0.24rem;
          color: #666666;
          padding: 0.18rem 0.18rem 0.12rem 0.18rem;
          margin-top: 0.18rem;
        }
      }
    }
  }
}
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 0.24rem;
  padding: 0.3rem 0;
}
.scrollTopBtn {
  position: fixed;
  bottom: 3rem;
  right: -0.14rem;
  width: 1.4rem;
}
.van-popup {
  .popup-title {
    font-size: 0.32rem;
    font-weight: 600;
    line-height: 0.32rem;
    text-align: center;
    margin-top: 0.4rem;
  }
  img {
    width:0.44rem;
    position: absolute;
    top: 0.34rem;
    right: 0.3rem
  }
  .popup-content {
    max-height: 70vh;
    overflow-y: auto;
    font-size: 0.28rem;
    display: flex;
    flex-direction: column; /* 设置为纵向排列 */
    justify-content: space-between;
    gap: 0.3rem;
    padding: 0.36rem 0.3rem 0.3rem 0.3rem;
  }
  .popup-footer {
    width: 100%;
    height: 1.72rem;
    display: flex;
    justify-content: center;
    border-top: 2px solid #E5E5E5;
    .footer-btn {
      width: 7.02rem;
      height: 0.88rem;
      border-radius: 0.56rem;
      font-size: 0.32rem;
      margin-top: 0.18rem;
      font-weight: 600;
      background: #FFCC33;
      display: flex;
      justify-content: center;
      align-items: center
    }
  }
}
.van-popup--round {
  border-radius: 0.24rem 0.24rem 0 0;
}
</style>
